var map = {
	"./template.betgalaxy": 2114,
	"./template.betgalaxy.tsx": 2114,
	"./template.betprofessor": 1063,
	"./template.betprofessor.tsx": 1063,
	"./template.betroyale": 1064,
	"./template.betroyale.tsx": 1064,
	"./template.default": 656,
	"./template.default.tsx": 656,
	"./template.fiestabet": 1065,
	"./template.fiestabet.tsx": 1065,
	"./template.puntcity": 1066,
	"./template.puntcity.tsx": 1066,
	"./template.puntgenie": 1067,
	"./template.puntgenie.tsx": 1067,
	"./template.questbet": 1068,
	"./template.questbet.tsx": 1068,
	"./template.ts": 966,
	"./template.volcanobet": 1069,
	"./template.volcanobet.tsx": 1069,
	"./template.wellbet": 1070,
	"./template.wellbet.tsx": 1070
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2419;